import React from "react"

import ActionButtons from "./ActionButtons"
import PaymentActionsMenu from "./PaymentActionsMenu"

import { CompanyStatus } from "@/graphql/codegen/graphql"
import { usePaymentTermsContext } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"

interface PaymentActionsProps {
  paymentTypeStatus?: CompanyStatus
  onDelete: () => void
  onEditPaymentType?: () => void
  onEditBankDetails?: () => void
  onDeactivate?: () => void
  onActivate?: () => void
}

const PaymentActions: React.FC<PaymentActionsProps> = ({
  paymentTypeStatus,
  onDelete,
  onEditPaymentType,
  onEditBankDetails,
  onDeactivate,
  onActivate,
}) => {
  const { companyStatus } = usePaymentTermsContext()
  const isCompanyPendingStatus = companyStatus === CompanyStatus.Pending

  if (isCompanyPendingStatus) {
    return (
      <ActionButtons onDelete={onDelete} onEditPaymentType={onEditPaymentType} onEditBankDetails={onEditBankDetails} />
    )
  }

  return (
    <PaymentActionsMenu
      paymentTypeStatus={paymentTypeStatus}
      onDelete={onDelete}
      onEditPaymentType={onEditPaymentType}
      onEditBankDetails={onEditBankDetails}
      onDeactivate={onDeactivate}
      onActivate={onActivate}
    />
  )
}

export default PaymentActions
